export var AudienceType;
(function (AudienceType) {
    AudienceType["SYNDICATED"] = "SYNDICATED";
    AudienceType["CUSTOM"] = "CUSTOM";
})(AudienceType || (AudienceType = {}));
export var AudiencePricingStructure;
(function (AudiencePricingStructure) {
    AudiencePricingStructure["CPM"] = "CPM";
    AudiencePricingStructure["PERCENT_MEDIA"] = "PERCENT_MEDIA";
    AudiencePricingStructure["HYBRID"] = "HYBRID";
})(AudiencePricingStructure || (AudiencePricingStructure = {}));
export var DSP;
(function (DSP) {
    DSP["THE_TRADE_DESK"] = "The Trade Desk";
    DSP["GOOGLE_DV360"] = "Google (DV360)";
    DSP["STACK_ADAPT"] = "StackAdapt";
    DSP["LINKEDIN_ADS"] = "LinkedIn Ads";
    DSP["META"] = "Meta";
    DSP["X"] = "X";
    DSP["TIKTOK_FOR_BUSINESS"] = "TikTok for Business";
    DSP["PINTEREST"] = "Pinterest";
    DSP["SNAPCHAT"] = "Snapchat";
    DSP["AMAZON_DSP"] = "Amazon DSP";
    DSP["ADOBE"] = "Adobe";
    DSP["PUBMATIC"] = "PubMatic";
    DSP["MEDIAMATH_BY_INFILLION"] = "MediaMath by Infillion";
    DSP["SIMPLI_FI"] = "Simpli.fi";
    DSP["MADHIVE"] = "Madhive";
    DSP["VIANT"] = "Viant";
    DSP["MOUNTAIN"] = "Mountain";
    DSP["BASIS"] = "Basis";
    DSP["ILLUMIN"] = "Illumin";
    DSP["RTB_HOUSE"] = "RTB House";
    DSP["SAMSUNG_ADS"] = "Samsung Ads";
    DSP["PARAMOUNT"] = "Paramount";
    DSP["LG_AD_SOLUTIONS"] = "LG Ad Solutions";
    DSP["WARNER_BROS_DISCOVERY"] = "Warner Bros. Discovery";
    DSP["COX_MEDIA"] = "Cox Media";
    DSP["SPECTRUM_CHARTER"] = "Spectrum / Charter";
})(DSP || (DSP = {}));
export var marketplaceDSPs = [
    'LinkedIn Ads',
    'Meta',
    'X',
    'TikTok for Business',
    'Pinterest',
    'Snapchat',
    'Amazon DSP',
    'Adobe',
    'PubMatic',
    'MediaMath by Infillion',
    'Simpli.fi',
    'Madhive',
    'Viant',
    'Mountain',
    'Basis',
    'Illumin',
    'RTB House',
    'Samsung Ads',
    'Paramount',
    'LG Ad Solutions',
    'Warner Bros. Discovery',
    'Cox Media',
    'Spectrum / Charter',
];
export var criteriaToSegmentLabels = {
    'Segments List': [],
    'Biotechnology Intent': [
        'Agritech',
        'Air Quality',
        'Bioproduction',
        'Clinical And Diagnostics',
        'Instruments',
        'Lab Automation',
        'Lab Data Management And Analysis',
        'Radiation Detection And Measurement',
    ],
    'Business Events': [
        'New Product Launches',
        'New Executive and Senior Personnel Hires',
        'Developing New Products/Offerings',
        'Expanding Facilities',
        'Recent Acquisitions',
        'Increasing Headcount',
        'New Location Openings',
        'Expanding Offices',
        'Received Financing',
        'Initial Public Offering (IPO)',
        'Recent Mergers',
    ],
    'Business Intent': [
        'Budgeting Planning and Strategy',
        'Compliance And Governance',
        'Funding And Loans',
        'Operations',
        'Sales',
    ],
    'Business Size Classification': [
        'Small Business',
        'Mid-Market Business Size',
        'Enterprise',
    ],
    'Decision Maker': [
        'Finance Decision Maker',
        'Information Technology Decision Maker',
        'Engineering Decision Maker',
        'Human Resources Decision Maker',
        'Legal Decision Maker',
        'Marketing Decision Maker',
        'Media and Communication Decision Maker',
        'Operations Decision Maker',
        'Sales Decision Maker',
    ],
    'Employee Count': [
        '1 to 10',
        '10 to 50',
        '50 to 100',
        '100 to 250',
        '250 to 500',
        '500 to 1,000',
        '1,000 to 2,500',
        '2,500 to 5,000',
        '5,000 to 10,000',
        '10,000 to 25,000',
        '25,000+',
    ],
    'Energy/Construction/Manufacturing Intent': [
        'Codes Standards And Regulations',
        'Construction',
        'Energy',
        'Engineering',
        'Manufacturing',
        'Personal Protective Equipment (Ppe)',
        'Supply Chain',
        'Tools And Hardware',
    ],
    'Finance Intent': [
        'Accounting',
        'Banking',
        'Business Finance',
        'Commodity',
        'Controls And Standards',
        'Corporate Finance',
        'Finance It',
        'Professional Services',
        'Trading And Investing',
        'Transactions And Payments',
    ],
    'Fortune 500': ['Fortune 500'],
    'Government Intent': [
        'Federal',
        'Military',
        'Research And Funding',
        'State And Local',
    ],
    'HealthCare Intent': [
        'Administration',
        'Benefits',
        'Disease Control',
        'Government Regulations',
        'Health Insurance',
        'Health Tech',
        'Marketing',
        'Medical Education',
        'Medical Research',
        'Medical Testing',
        'Medical Treatment',
        'Patient Management',
        'Pharmaceuticals',
    ],
    'Human Resources Intent': [
        'Benefits',
        'Diversity And Inclusion',
        'Employee Services',
        'Hr Tech',
        'Labor Relations',
        'Leadership And Strategy',
        'Legal And Regulatory',
        'Payroll And Compensation',
        'Performance',
        'Policy And Culture',
        'Recruitment Hiring and Onboarding',
        'Staff Administration',
        'Training And Development',
        'Wellness And Safety',
    ],
    Industry: [
        'Accommodation Services',
        'Administrative and Support Services',
        'Construction',
        'Consumer Services',
        'Education',
        'Entertainment Providers',
        'Farming, Ranching, Forestry',
        'Financial Services',
        'Government Administration',
        'Holding Companies',
        'Hospitals and Health Care',
        'Manufacturing',
        'Oil, Gas, and Mining',
        'Professional Services',
        'Real Estate and Equipment Rental Services',
        'Retail',
        'Technology, Information and Media',
        'Transportation, Logistics, Supply Chain and Storage',
        'Utilities',
        'Wholesale',
        'Accounting',
        'Administration of Justice',
        'Advertising Services',
        'Airlines and Aviation',
        'Apparel Manufacturing',
        'Appliances, Electrical, and Electronics Manufacturing',
        'Architecture and Planning',
        'Artists and Writers',
        'Building Construction',
        'Business Consulting and Services',
        'Capital Markets',
        'Chemical Manufacturing',
        'Civic and Social Organizations',
        'Civil Engineering',
        'Climate Technology Products Manufacturing',
        'Collection Agencies',
        'Community Services',
        'Computers and Electronics Manufacturing',
        'Credit Intermediation',
        'Design Services',
        'E-Learning Providers',
        'Economic Programs',
        'Electric Power Generation',
        'Electric Power Transmission, Control, and Distribution',
        'Engineering Services',
        'Environmental Quality Programs',
        'Equipment Rental Services',
        'Events Services',
        'Fabricated Metal Products',
        'Facilities Services',
        'Farming',
        'Food and Beverage Manufacturing',
        'Food and Beverage Retail',
        'Food and Beverage Services',
        'Forestry and Logging',
        'Freight and Package Transportation',
        'Fundraising',
        'Funds and Trusts',
        'Furniture and Home Furnishings Manufacturing',
        'Glass, Ceramics and Concrete Manufacturing',
        'Ground Passenger Transportation',
        'Health and Human Services',
        'Higher Education',
        'Hospitality',
        'Hospitals',
        'Household Services',
        'Housing and Community Development',
        'IT Services and IT Consulting',
        'Individual and Family Services',
        'Insurance',
        'Leather Product Manufacturing',
        'Legal Services',
        'Machinery Manufacturing',
        'Maritime Transportation',
        'Market Research',
        'Media and Telecommunications',
        'Medical Equipment Manufacturing',
        'Medical Practices',
        'Military and International Affairs',
        'Mining',
        'Museums, Historical Sites, and Zoos',
        'Musicians',
        'Natural Gas Distribution',
        'Non-profit Organizations',
        'Nursing Homes and Residential Care Facilities',
        'Office Administration',
        'Oil and Coal Product Manufacturing',
        'Oil and Gas',
        'Online and Mail Order Retail',
        'Paper and Forest Product Manufacturing',
        'Performing Arts and Spectator Sports',
        'Personal and Laundry Services',
        'Philanthropic Fundraising Services',
        'Photography',
        'Pipeline Transportation',
        'Plastics and Rubber Product Manufacturing',
        'Postal Services',
        'Primary Metal Manufacturing',
        'Primary and Secondary Education',
        'Printing Services',
        'Professional Training and Coaching',
        'Public Policy Offices',
        'Rail Transportation',
        'Ranching and Fisheries',
        'Real Estate',
        'Recreational Facilities',
        'Religious Institutions',
        'Repair and Maintenance',
        'Research Services',
        'Retail Apparel and Fashion',
        'Retail Appliances, Electrical, and Electronic Equipment',
        'Retail Art Dealers',
        'Retail Art Supplies',
        'Retail Books and Printed News',
        'Retail Building Materials and Garden Equipment',
        'Retail Florists',
        'Retail Furniture and Home Furnishings',
        'Retail Gasoline',
        'Retail Health and Personal Care Products',
        'Retail Luxury Goods and Jewelry',
        'Retail Motor Vehicles',
        'Retail Musical Instruments',
        'Retail Office Equipment',
        'Retail Office Supplies and Gifts',
        'Retail Recyclable Materials and Used Merchandise',
        'Security and Investigations',
        'Services for Renewable Energy',
        'Space Research and Technology',
        'Specialty Trade Contractors',
        'Sporting Goods Manufacturing',
        'Staffing and Recruiting',
        'Technical and Vocational Training',
        'Technology, Information and Internet',
        'Telephone Call Centers',
        'Textile Manufacturing',
        'Translation and Localization',
        'Transportation Equipment Manufacturing',
        'Travel Arrangements',
        'Truck Transportation',
        'Veterinary Services',
        'Warehousing and Storage',
        'Water, Waste, Steam, and Air Conditioning Services',
        'Wholesale Apparel and Sewing Supplies',
        'Wholesale Appliances, Electrical, and Electronics',
        'Wholesale Building Materials',
        'Wholesale Chemical and Allied Products',
        'Wholesale Computer Equipment',
        'Wholesale Drugs and Sundries',
        'Wholesale Food and Beverage',
        'Wholesale Footwear',
        'Wholesale Furniture and Home Furnishings',
        'Wholesale Hardware, Plumbing, Heating Equipment',
        'Wholesale Import and Export',
        'Wholesale Luxury Goods and Jewelry',
        'Wholesale Machinery',
        'Wholesale Metals and Minerals',
        'Wholesale Motor Vehicles and Parts',
        'Wholesale Paper Products',
        'Wholesale Petroleum and Petroleum Products',
        'Wholesale Photography Equipment and Supplies',
        'Wholesale Raw Farm Products',
        'Wholesale Recyclable Materials',
        'Wood Product Manufacturing',
        'Writing and Editing',
        'Tobacco Manufacturing',
        'Wholesale Alcoholic Beverages',
    ],
    'Job Seniority': [
        'C-Level',
        'VP',
        'Director',
        'Manager',
        'Staff',
        'Staff+',
        'Manager+',
        'Director+',
    ],
    'Job Function': [
        'Administrative',
        'Community and Social Services',
        'Education',
        'Engineering',
        'Executive',
        'Finance',
        'Government',
        'Health Services',
        'Human Resources',
        'Information Technology',
        'Legal',
        'Marketing',
        'Media and Communications',
        'Military and Protective Services',
        'Operations',
        'Product Management',
        'Real Estate',
        'Sales',
    ],
    'Legal Intent': [
        'Business Structure',
        'Contracts',
        'Intellectual Property',
        'Lawtech',
        'Legal Services',
        'Taxation',
    ],
    'Logistics Intent': [
        'Information Management',
        'Storage',
        'Transportation',
        'Warehousing',
    ],
    Longevity: [
        'New Business (<1Year)',
        'Established Business (>2Years)',
        'Unknown',
    ],
    'Marketing Intent': [
        'Ad Tech',
        'Agencies',
        'Branding',
        'Content',
        'Customer Relationship Management (Crm)',
        'Demand Generation',
        'Email And Sms Marketing',
        'Mobile',
        'Search Marketing',
        'Social',
        'Strategy And Analysis',
        'Website Publishing',
    ],
    'Retail Intent': ['Ecommerce', 'Retail Technology'],
    'Revenue Size': [
        '$1 to $1,000,000',
        '$1,000,000 to $5,000,000',
        '$5,000,000 to $10,000,000',
        '$10,000,000 to $50,000,000',
        '$50,000,000 to $100,000,000',
        '$100,000,000 to $250,000,000',
        '$250,000,000 to $500,000,000',
        '$500,000,000 to $1,000,000,000',
        '$1,000,000,000+',
    ],
    Technologies: [
        'Academic And Education Management',
        'Accommodation And Food Services',
        'Antivirus And Antimalware Applications',
        'Application And Desktop Virtualization',
        'Application Development Technologies',
        'Application Lifecycle Management',
        'Application Server Software',
        'Applications',
        'Architectural And Engineering',
        'Arts, Entertainment, and Recreation Software',
        'Big Data Analytical Tools',
        'Business Intelligence Dashboard And Platforms',
        'Business Performance Management',
        'Business Process Management',
        'Business Productivity',
        'Case Management',
        'Communication And Collaboration Solutions',
        'Computer Networking Components',
        'Construction',
        'Contact Center Management',
        'Content Delivery Networks (CDNs)',
        'Continuous Integration and Deployment (CI/CD) Tools',
        'Customer Engagement',
        'Customer Experience Management',
        'Customer Order Management',
        'Customer Relationship Management (CRM)',
        'Data Backup Recovery And Archives',
        'Data Center And Colocation Infrastructure',
        'Data Integration Tools',
        'Data Science And Statistical Platforms',
        'Data Visualization And Data Discovery Tools',
        'Database Management Systems (DBMS)',
        'Design And Visualization',
        'Design Tools',
        'Desktop Computers',
        'Development Platforms And Environments',
        'Digital Advertising',
        'Digital Analytics',
        'Digital Asset Management (DAM)',
        'Disaster Recovery',
        'Document Management',
        'E-Commerce Solutions And Platforms',
        'Electronic Computer And Hardware Technologies',
        'Electronic Data Interchange (EDI)',
        'Electronic Design Automation Solutions',
        'Email Marketing',
        'Email Security',
        'Email Software And Applications',
        'Endpoint Security Solutions And Unified Threat Management',
        'Enterprise Applications',
        'Enterprise Asset Management (EAM)',
        'Enterprise Content Management (ECM)',
        'Enterprise Resource Planning (ERP)',
        'Enterprise Resource Solutions',
        'Environmental Health And Safety (EHS)',
        'Finance And Insurance',
        'Financial Management Systems (FMS)',
        'Firewall Appliances',
        'Firewall Applications',
        'Gateways',
        'Geographic Information Systems (GIS)',
        'Governance Risk Compliance (GRC)',
        'Government And Public Administration',
        'Graph Database Management Systems',
        'Hardware, Devices, Computing, and Storage Solutions',
        'Health Care And Medical Management',
        'Help Desk Management',
        'HR Management System (HRMS) and Human Capital Management (HCM)',
        'Hybrid Database Management Systems',
        'Information Technology Management',
        'Infrastructure as a Service (IaaS)',
        'Internet Services',
        'Intrusion Protection Systems',
        'Inventory And Warehouse Management',
        'IP-PBX Phone Systems',
        'IT Infrastructure and Operation Management',
        'Learning Management Systems (LMS)',
        'Legal And Professional Services Management',
        'Managed Services',
        'Manufacturing And Operations',
        'Marketing Solutions',
        'Media Publishers And Applications',
        'Middleware Applications',
        'Mobile And Tablet Operating Systems',
        'Mobile Device Management',
        'Multilayer Switches',
        'Network Computing',
        'WAN Maintenance',
        'Network Management',
        'Newsql Database Management Systems',
        'Next-Generation Firewalls',
        'NoSQL Database Management Systems',
        'Office And Peripheral Supplies',
        'Online Video Platforms',
        'Other Web Technologies And Platforms',
        'Partner Management',
        'Pbx Support Services',
        'PC Desktop and Laptop Operating Systems',
        'Peripheral And Communication Components',
        'Peripherals And Communication Solutions',
        'Personal Digital Assistants Pda',
        'Philanthropic Software And Applications',
        'Platform as a Service (PaaS)',
        'Platform Virtualization Software',
        'Portfolio Management',
        'Procurement',
        'Product Lifecycle Management (PLM)',
        'Programming Languages',
        'Project Management',
        'Publishing Tools',
        'Quality Assurance Tools',
        'Quality Management Software',
        'Real Estate Software',
        'Relational Database Management Systems (RDBMS)',
        'Retail Trade',
        'Routers',
        'Sales Enablement Platforms',
        'Search Engine Optimization (SEO)',
        'Search Engines',
        'Security And Identity Governance',
        'Security Information and Event Management (SIEM)',
        'Security Software',
        'Server And Workstation Operating Systems',
        'Servers, Mainframes, Midframes, and Computing Solutions',
        'Service & Field Support Management',
        'Social Media And Community Platforms',
        'Software Configuration',
        'Special Event Management',
        'SSL and Digital Certificates',
        'Storage Management',
        'Storage Solutions And Appliances',
        'Supplier Relationship Management (SRM)',
        'Supply Chain Management and Planning (SCM)',
        'Switches',
        'System Software',
        'Telecommunication Solutions',
        'Transport Management',
        'Travel And Expenses',
        'Update and Change Management',
        'Value Stream Mapping',
        'Vertical Market Specialised Solutions',
        'Vertical Specific Solutions',
        'Virtualization Platform Management',
        'Web Content Management Systems (CMS)',
    ],
    'Technology Intent': [
        'Analytics And Reporting',
        'Apis And Services',
        'Artificial Intelligence And Machine Learning',
        'Business Solutions',
        'Cloud',
        'Data Center',
        'Data Management',
        'Database',
        'Desktop',
        'Document Management',
        'Emerging Tech',
        'Enterprise',
        'Hardware',
        'It Management',
        'Mobile',
        'Monitoring',
        'Operating System',
        'Programming Languages',
        'Robotics',
        'Security And Privacy',
        'Servers',
        'Software Engineering',
        'Storage',
        'Telecommunications And Networking',
        'Translation And Language',
        'Video',
        'Virtual Reality (Vr) And Augmented Reality (Ar)',
        'Virtualization',
        'Wireless',
    ],
};
//# sourceMappingURL=Audience.js.map